module.exports = "<div class=\"panel panel-primary\">\r\n    <div class=\"row\">Time is up!</div>\r\n</div>"